/**
 * Эвристика: id из armenianBelotLocalUiAnimationsReference, релевантные cmd/events.
 * @module game/belotArmenian/engineDebugUiHints
 */

/**
 * @param {unknown} cmd
 * @param {unknown[]} events
 * @returns {string[]}
 */
function inferTriggeredAnimationIds(cmd, events) {
  /** @type {Set<string>} */
  const ids = new Set();
  const ct = cmd && typeof cmd === 'object' ? String(/** @type {{ type?: string }} */ (cmd).type || '') : '';
  const evTypes = Array.isArray(events)
    ? events.map((e) => (e && typeof e === 'object' ? String(/** @type {{ type?: unknown }} */ (e).type || '') : ''))
    : [];

  if (ct === 'START_ROUND') ids.add('deal_flight');
  if (ct === 'BID' || ct === 'PASS' || ct === 'CONTRA' || ct === 'RECONTRA') ids.add('auction_contract_reveal');
  if (ct === 'PLAY_CARD') {
    ids.add('hero_play_drag_snap');
    ids.add('bot_play_card_flight');
    if (evTypes.includes('TRICK_WON')) {
      ids.add('trick_end_collect');
      ids.add('trick_collect_kapot_glow');
    }
  }
  if (evTypes.includes('TRICK_WON')) ids.add('combo_decl_scoring_reveal');
  if (ct === 'COMMIT_FIRST_PLAY_DECLARATIONS') ids.add('hardcore_combo_announce_reveal');
  if (evTypes.includes('CARD_PLAYED') || ct === 'PLAY_CARD') ids.add('void_lead_renounce_cue');
  if (evTypes.some((t) => /DIRTY|DIRTY_|ACCUSE/i.test(t))) ids.add('shuler_local_fx');
  if (ct === 'END_DECLARE_PHASE') ids.add('declare_strip_battle_outcome');
  if (evTypes.some((t) => /BELA|DECLARATIONS_RESOLVED/i.test(t))) ids.add('bela_blot_reblot_bubble');
  if (evTypes.includes('ROUND_SCORED') || evTypes.includes('MATCH_ENDED')) {
    ids.add('match_settlement_numbers');
    if (evTypes.includes('MATCH_ENDED')) ids.add('match_end_splash');
  }

  return [...ids].sort();
}

/**
 * @param {string} message
 * @returns {string}
 */
function inferValidationCode(message) {
  const m = String(message || '');
  const cut = m.indexOf(':');
  const head = cut >= 0 ? m.slice(0, cut).trim() : m.trim();
  return head.replace(/^armenian\/engine:\s*/i, '').replace(/\s+/g, '_').slice(0, 80) || 'ENGINE_ERROR';
}

module.exports = {
  inferTriggeredAnimationIds,
  inferValidationCode,
};
